import { graphql } from "relay-runtime"

export const chUpdateAllPatientGynaecologyMutation = graphql`
  mutation chUpdateAllPatientGynaecologyMutation($input: Ch_updatePatientGynaecologyInput!) {
    updateAllPatientGynaecology: ch_updatePatientGynaecology(input: $input) {
      errors {
        ... on Error {
          message
        }
        ... on IneligibleForGynaecology {
          message
        }
        ... on PatientNotFound {
          patientId
          message
        }
      }
      gynaecology {
        firstPeriod
        id
        menopauseSince
        patientId
        pregnancy
        pregnancyHistory
        weeksOfPregnancy
      }
    }
  }
`
